{
  "title": "Thunderwave",
  "source": "Player's Handbook",
  "levelAndSchool": "1st-level evocation",
  "level": 1,
  "castingTime": "1 action",
  "range": "Self (15-foot cube)",
  "components": "V, S",
  "duration": "Instantaneous",
  "description": [
    "A wave of thunderous force sweeps out from you. Each creature in a 15-foot cube originating from you must make a Constitution saving throw. On a failed save, a creature takes 2d8 thunder damage and is pushed 10 feet away from you. On a successful save, the creature takes half as much damage and isn’t pushed.",
    "In addition, unsecured objects that are completely within the area of effect are automatically pushed 10 feet away from you by the spell’s effect, and the spell emits a thunderous boom audible out to 300 feet.",
    "At Higher Levels. When you cast this spell using a spell slot of 2nd level or higher, the damage increases by 1d8 for each slot level above 1st."
  ],
  "spellLists": ["bard", "druid", "eldritch-knight", "sorcerer", "wizard"]
}
